import { render, staticRenderFns } from "./VsTh.vue?vue&type=template&id=fe79c500"
import script from "./VsTh.vue?vue&type=script&lang=js"
export * from "./VsTh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports